import { HeadData } from '@/components/HeadData';
import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import { CourseLessonDocumentPageComponent } from '..';

export const COURSE_LESSON_DOCUMENT_FRAGMENT = graphql(/* GraphQL */ `
  fragment EmbaCourseLessonDocument on CourseLessonDocument {
    id
    fileRedirectUrl
    description
  }
`);

export type CourseLessonDocumentContainerProps = {
  content: FragmentType<typeof COURSE_LESSON_DOCUMENT_FRAGMENT>;
  lessonName: string;
  chapterName: string;
  userAttendanceSlug: string;
  onEmbaStartCourseLesson: () => Promise<void>;
  onEmbaCompleteCourseLesson: () => Promise<void>;
  isLoading: boolean;
  headTitle: string;
};

export const CourseLessonDocumentContainer = ({
  content,
  lessonName,
  chapterName,
  onEmbaStartCourseLesson,
  onEmbaCompleteCourseLesson,
  isLoading,
  headTitle,
}: CourseLessonDocumentContainerProps) => {
  const embaCourseLessonDocumentData = useFragment(
    COURSE_LESSON_DOCUMENT_FRAGMENT,
    content,
  );

  const onClickDownload = async () => {
    await onEmbaStartCourseLesson();
    await onEmbaCompleteCourseLesson();
    window.open(embaCourseLessonDocumentData.fileRedirectUrl, '_blank');
  };

  return (
    <>
      <HeadData title={headTitle} />
      <CourseLessonDocumentPageComponent
        lessonName={lessonName}
        chapterName={chapterName}
        description={embaCourseLessonDocumentData.description}
        onClickDownload={onClickDownload}
        isLoading={isLoading}
      />
    </>
  );
};
